import * as React from 'react'
import StageHeader from '../../shared/StageHeader'
import FormLayout from '../../shared/FormLayout'

import { useContractForm } from '@/modules/drivers/context/ContractFormContext'
import CheckboxWithLabelField from '../inputs/CheckboxWithLabelField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import LifeInsurance from '../components/taxes/LifeInsurance'
import MedicalCover from '../components/taxes/MedicalCover'
import Clothes from '../components/taxes/Clothes'
import BhpAddition from '../components/taxes/BhpAddition'
import CustomAdditions from '../components/taxes/CustomAdditions'
import CustomDeductions from '../components/taxes/CustomDeductions'
import RateReduceCustom from '../components/shared/RateReduceCustom'

const ContractTaxes = () => {
  const { t } = useLocalize()
  const { setData, data } = useContractForm()

  const checkboxesForWages = [
    {
      field: 'isAdditionForLaundryEnabled',
      label: t('contract.laundry-addition'),
      children: (
        <>
          <Clothes setData={setData} data={data} />
          <RateReduceCustom
            data={data}
            setData={setData}
            reduceType="additional"
            mainCheckboxProperty="reduceAdditionForLaundry"
            sickLeaveProperty="reduceAdditionForLaundryForSickLeave"
            paidLeaveProperty="reduceAdditionForLaundryForLeave"
            unpaidLeaveProperty="reduceAdditionForLaundryForNotPaidLeave"
          />
        </>
      ),
    },
    {
      field: 'isDeductionForMedicalInsuranceEnabled',
      label: t('contract.medical-insurance-deduction'),
      children: <MedicalCover setData={setData} data={data} />,
    },
    {
      field: 'isLifeInsuranceEnabled',
      label: t('contract.group-life-insurance'),
      children: <LifeInsurance setData={setData} data={data} />,
    },
    {
      field: 'isAdditionForBhpEnabled',
      label: t('contract.bhp-addition'),
      children: (
        <>
          <BhpAddition setData={setData} data={data} />
          <RateReduceCustom
            data={data}
            setData={setData}
            reduceType="additional"
            mainCheckboxProperty="reduceAdditionForBhp"
            sickLeaveProperty="reduceAdditionForBhpForSickLeave"
            paidLeaveProperty="reduceAdditionForBhpForLeave"
            unpaidLeaveProperty="reduceAdditionForBhpForNotPaidLeave"
          />
        </>
      ),
    },
  ]

  return (
    <div className="tw-flex tw-min-h-[500px] tw-justify-between">
      <StageHeader title={t('contract.taxes-and-deductions')} />
      <FormLayout>
        <div>
          {checkboxesForWages.map((c, i) => (
            <CheckboxWithLabelField
              key={i}
              field={c.field as keyof typeof data}
              data={data}
              setData={setData}
              label={c.label}
            >
              {c.children}
            </CheckboxWithLabelField>
          ))}
        </div>

        <div className="tw-border-border-default tw-mt-6 tw-border-t tw-pt-4">
          <h3 className="tw-text-content-default tw-mb-3 tw-px-5 tw-text-sm tw-font-medium">
            {t('contract.custom-wage-components')}
          </h3>
          <CustomAdditions setData={setData} data={data} />
        </div>

        <div className="tw-border-border-default tw-mt-6 tw-border-t tw-pt-4">
          <h3 className="tw-text-content-default tw-mb-3 tw-px-5 tw-text-sm tw-font-medium">
            {t('contract.custom-deductions')}
          </h3>
          <CustomDeductions setData={setData} data={data} />
        </div>
      </FormLayout>
    </div>
  )
}
export default ContractTaxes
